import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import BuildIcon from '@mui/icons-material/Build';
import PersonIcon from '@mui/icons-material/Person';

const columns = [
    { field: 'title_id', headerName: 'ลำดับ', width: 90, sortable: false },
    {
      field: 'product_name',
      headerName: 'รายการสินค้า',
      width: 150,
      editable: true,
      sortable: false
    },
    {
      field: 'scale',
      headerName: 'ขนาด/ชนิด',
      width: 150,
      editable: true,
      sortable: false
    },
    {
      field: 'unit',
      headerName: 'หน่วย',
      type: 'number',
      width: 110,
      editable: true,
      sortable: false
    },
    {
      field: 'fullName',
      headerName: 'Full name',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
    },
  ];

  
const HeaderWithIconRoot = styled('div')(({ theme }) => ({
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    '& span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginRight: theme.spacing(0.5),
    },
  }));
  
  function HeaderWithIcon(props) {
    const { icon, ...params } = props;
  
    return (
      <HeaderWithIconRoot>
        <span>{params.headerName ?? params.groupId}</span> {icon}
      </HeaderWithIconRoot>
    );
  }

  const columnGroupingModel = [
    {
      groupId: 'ราคา ต่ำ-สูง',
      headerAlign: 'center',
      children: [
        { 
          groupId: '(1)',
          headerAlign: 'center',
          children: [
            {
              groupId: 'สัปดาห์ที่ 1',
              headerAlign: 'center',
              children: [
                {
                  groupId: '1/8/2566',
                  headerAlign: 'center',
                }
              ]
            }
          ]
        }, 
        {
          groupId: '(2)',
          headerAlign: 'center',
          children: [
            {
              groupId: 'เฉลี่ย',
              headerAlign: 'center',
              children: [
                {
                  groupId: '',
                  headerName: '',
                }
              ]
            }
          ]
        },
        { 
          groupId: '(3)',
          headerAlign: 'center',
          children: [
            {
              groupId: 'สัปดาห์ที่ 1',
              headerAlign: 'center',
              children: [
                {
                  groupId: '1/8/2566',
                  headerAlign: 'center',
                }
              ]
            }
          ]
        },
        {
          groupId: '(4)',
          headerAlign: 'center',
          children: [
            {
              groupId: 'เฉลี่ย',
              headerAlign: 'center',
              children: [
                {
                  groupId: '',
                  headerName: '',
                }
              ]
            }
          ]
        },
      ],
    },
    {
      groupId: 'เปลี่ยนแปลง',
      headerAlign: 'center',
      children: [
        {
          groupId: '(4) - (2)',
          headerAlign: "center",
          children: [
            { 
                groupId: 'บาท',
                headerAlign:"center",
                children: [
                  {
                    groupId: '',
                  }
                ]
            },
          ],
        },
        {
          groupId: 'ร้อยละ',
          headerAlign:"center",
        },
      ],
    },
  ];

  const fakeData = [
    {
      title_id: 1,
      title_name: "ข้าวสารบรรจุถุง",
      info: [
        {
          product_name: "หงษ์ทอง ข้าวหอมมะลิ 100% (คัดพิเศษ)",
          scale: "(5กก./ถุง)",
          unit: "ถุง",
          week1: "209.00 - 215.00",
          week1Avg: "212",
          week2: "209.00 - 239.00",
          week2Avg: "224",
          baht: "12",
          percent: "5.66",
        },
        {
          product_name: "เบญจรงค์ ข้าวหอมมะลิ 100%",
          scale: "5 กก.",
          unit: "ถุง",
          week1: "165.00 - 198.00",
          week1Avg: "181.5",
          week2: "167.00 - 198.00",
          week2Avg: "182.5",
          baht: "1",
          percent: "0.55",
        },
        {
          product_name: "เบญจรงค์ ข้าวสาวไห้ 100%",
          scale: "5 กิโลกรัม",
          unit: "ถุง",
          week1: "105.00 - 132.00",
          week1Avg: "118.5",
          week2: "105.00 - 128.00",
          week2Avg: "116.5",
          baht: "-2",
          percent: "-1.69",
        },
      ]
    },
    {
      title_id: 2,
      title_name: "นมผง",
      info: [
        {
          product_name: "ตราหมี ADVANCE PROTEXTION L.RHAMNOSUS รสน้ำผึ้ง",
          scale: "550 กรัม",
          unit: "กล่อง",
          week1: "194.00 - 216.00",
          week1Avg: "205",
          week2: "194.00 - 216.00",
          week2Avg: "205",
          baht: "",
          percent: "",
        },
        {
          product_name: "เบญจรงค์ ข้าวหอมมะลิ 100%",
          scale: "550 กรัม",
          unit: "กล่อง",
          week1: "251.00 - 279.00",
          week1Avg: "265",
          week2: "251.00 - 279.00",
          week2Avg: "265",
          baht: "",
          percent: "",
        },
      ]
    },
  ]

  const columns2 = [
    { field: 'id',headerAlign:"center", headerName: 'ID', width: 90 },
    {
      field: 'product_name',
      headerName: 'รายการสินค้า',
      headerAlign:"center",
      width: 150,
      editable: true,
      sortable: false
    },
    {
      field: 'scale',
      headerName: 'ขนาด/ชนิด',
      headerAlign:"center",
      width: 150,
      editable: true,
      sortable: false
    },
    {
      field: 'unit',
      headerName: 'หน่วย',
      headerAlign:"center",
      type: 'number',
      width: 110,
      editable: true,
      sortable: false
    },
    {
      field: 'firstName',
      headerAlign:"center",
      headerName: 'First name',
      width: 150,
    },
    {
      field: 'lastName',
      headerAlign:"center",
      headerName: 'Last name',
      width: 150,
    },
    {
      field: 'age',
      headerName: 'Age',
      headerAlign:"center",
      type: 'number',
      width: 110,
    },
  ];
  
  const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35 },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42 },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45 },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16 },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150 },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44 },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36 },
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65 },
  ];
  
  const columnGroupingModel2 = [
    {
      groupId: 'Basic info',
      headerAlign: 'center',
      children: [
        {
          groupId: 'Full name',
          headerAlign: 'center',
          children: [{ field: 'firstName' }, { field: 'lastName' }],
        },
        { field: 'age' },
      ],
    },
  ];
  

const TestReport = () => {
  return (
    <React.Fragment>
        <div 
            style={{
                position:"relative",
                display:"flex",
                justifyContent:"center",
                background:"#222736"
            }}
        >
            <Container
                style={{
                    height:"100vh",
                    position:"relative",
                    zIndex:"1",
                }}
            >
                <Card 
                    style={{
                        height:"100%",
                        background: "#32394e",
                    }} 
                    className='mb-0'
                >
                    <CardBody className='bg-white'>
                    <CardTitle>ภาวะราคาสินค้าอุปโภคบริโภค 183 รายการ เปรียบเทียบรายสัปดาห์ (รายจังหวัด)</CardTitle>
                    <CardTitle>ภาคกลาง จังหวัด กรุงเทพฯ <strong className='text-white'>/</strong> สัปดาห์ที่ 1 เดือน สิงหาคม 2566 เทียบกับ สัปดาห์ที่ 2 เดือน สิงหาคม 2566</CardTitle>
                    <div style={{ height: 400, width: '100%' }}>
                    <DataGrid
                      sx={{verticalAlign:"middle"}}
                      experimentalFeatures={{ columnGrouping: true }}
                      rows={rows}
                      columns={columns2}
                      disableColumnMenu
                      disableColumnSelector
                      disableDensitySelector
                      disableRowSelectionOnClick
                      disableVirtualization
                      disableColumnFilter
                      columnGroupingModel={columnGroupingModel2}
                    />
                    </div>
                    </CardBody>
                </Card>
            </Container>
        </div>
    </React.Fragment>
  )
}

export default TestReport